import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as Alert } from "../../img/svg/alert.svg";


function Intro() {
    return (
        <div className="card">
        <div className="card-content">

            <div className="col-2">
                <div><Alert className="alert-icon"/></div>
                <div><h2>Hot Spots for Trout</h2></div>
            </div>
        </div>
        <div className="card-content">
            <h2>Thank you for volunteering in this citizen science activity.</h2>
            <p>If you have questions on how to conduct a water quality survey click
                <NavLink to="/info"> here.</NavLink> </p>
        </div>
    </div>
    )
}

export default Intro
